import { Chip, createStyles, makeStyles } from "@material-ui/core"
import { colors } from "../../../utils/theme"

interface TranscriptStatusChipProps {
  status: string
}

/**
 * Renders a transcript session status chip with styling based on its status.
 */
export default function TranscriptStatusChip({
  status,
}: TranscriptStatusChipProps) {
  const classes = useStyles()
  const colorClassName =
    status === "complete"
      ? classes.completeStatus
      : status === "error"
      ? classes.errorStatus
      : classes.processingStatus

  return (
    <Chip
      size="small"
      label={status.replace("_", " ")}
      className={`${classes.chip} ${colorClassName}`}
    />
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    chip: {
      height: 28,
      borderRadius: 8,
      fontSize: 13,
      fontWeight: 600,
      letterSpacing: "0.01em",
      lineHeight: 1.2,
      textTransform: "capitalize",
      "& .MuiChip-label": {
        paddingLeft: 10,
        paddingRight: 10,
      },
    },
    processingStatus: {
      backgroundColor: colors.primary.cloud,
      color: colors.primary.midnight,
    },
    completeStatus: {
      backgroundColor: "#E7F7EC",
      color: colors.graphs.alerts.positive,
    },
    errorStatus: {
      backgroundColor: colors.secondary.blush,
      color: colors.secondary.crimson,
    },
  })
)
